import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import WishlistGrid from '../../components/wishlist/WishlistGrid';
import Button from '../../components/common/Button';
import { useWishlist } from '../../hooks/useWishlist';
import { theme } from '../../config/theme';
import { ArrowLeftIcon } from '../../components/icons/Icons';

const Wishlist = () => {
  const navigate = useNavigate();
  const { items, loading, fetchWishlist, clearWishlist } = useWishlist();

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '1200px', margin: '0 auto' }}>
        <Button 
          variant="ghost"
          size="md"
          onClick={() => navigate('/products')}
          style={{ marginBottom: theme.spacing.lg }}
        >
          <ArrowLeftIcon size={18} />
          Continue Shopping
        </Button>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: theme.spacing.xl,
        }}>
          <div>
            <h1 style={{ 
              fontSize: theme.typography.fontSize['3xl'], 
              fontWeight: theme.typography.fontWeight.bold,
              marginBottom: theme.spacing.xs,
            }}>
              My Wishlist
            </h1>
            <p style={{ color: theme.colors.text.secondary }}>
              {items.length} {items.length === 1 ? 'item' : 'items'}
            </p>
          </div>

          {items.length > 0 && (
            <Button
              variant="secondary"
              size="md"
              onClick={clearWishlist}
            >
              Clear Wishlist
            </Button>
          )}
        </div>

        <WishlistGrid items={items} loading={loading} />
      </div>
    </MainLayout>
  );
};

export default Wishlist;